import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getApiBaseUrl } from "../services/api";

const Login = () => {
  const { isAuthenticated, isAdmin } = useAuth();
  const [error, setError] = useState("");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const API_URL = getApiBaseUrl();

  useEffect(() => {
    // Check for error params from OAuth callback
    const errorParam = searchParams.get("error");
    if (errorParam === "auth_failed") {
      setError("Authentication failed. Please try again.");
    } else if (errorParam === "not_authorized") {
      setError("Access denied. Admin privileges required.");
    }
  }, [searchParams]);

  useEffect(() => {
    if (isAuthenticated && isAdmin) {
      navigate("/portal");
    }
  }, [isAuthenticated, isAdmin, navigate]);

  const handleGoogleLogin = () => {
    // Redirect to backend OAuth endpoint
    window.location.href = `${API_URL}/auth/google?state=lig`;
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          textAlign: "center",
          maxWidth: "400px",
          width: "100%",
        }}
      >
        <h1 style={{ marginBottom: "10px", color: "#333" }}>Admin Portal</h1>
        <p style={{ color: "#666", marginBottom: "30px" }}>
          Sign in with your Google account to access the admin portal
        </p>

        <button
          onClick={handleGoogleLogin}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            width: "100%",
            padding: "12px 24px",
            backgroundColor: "white",
            border: "1px solid #dadce0",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
            color: "#3c4043",
            transition: "background-color 0.2s",
            margin: "0 auto",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "white")}
        >
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path
              fill="#4285F4"
              d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z"
            />
            <path
              fill="#34A853"
              d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17z"
            />
            <path
              fill="#FBBC05"
              d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18l2.67-2.07z"
            />
            <path
              fill="#EA4335"
              d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.3z"
            />
          </svg>
          Sign in with Google
        </button>

        {error && (
          <div
            style={{
              backgroundColor: "#fee",
              color: "#c33",
              padding: "12px",
              borderRadius: "4px",
              marginTop: "20px",
              fontSize: "14px",
              textAlign: "left",
            }}
          >
            {error}
          </div>
        )}

        <p
          style={{
            fontSize: "12px",
            color: "#999",
            marginTop: "20px",
          }}
        >
          Only authorized admin accounts can access the portal
        </p>
      </div>
    </div>
  );
};

export default Login;
